import React, { useEffect, useState } from 'react';
import { layout, palette, Radio, typography } from '@citrite/web-ui-component';
import styled from '@emotion/styled';
import { DesktopAction } from 'App/Activity/ResourceManagerContext';

export interface SubActionOption {
	action: DesktopAction;
	label: string;
	description: string;
}

interface Props {
	onChange: (value: DesktopAction) => void;
	subActionOptions: SubActionOption[];
	defaultValue?: DesktopAction;
}

const OptionsContainer = styled.div`
	margin-top: ${layout.mediumSpace};
	display: flex;
	flex-direction: column;
	gap: ${layout.space16};
`;

const StyledRadio = styled(Radio)`
	gap: ${layout.space16};
	align-items: center;
	.checkbox-radio-label {
		padding-top: 1px;
		margin-left: 0;
		span {
			font-weight: ${typography.weights.semiBold} !important;
		}
	}
`;

const OptionDescription = styled.div`
	margin-left: 38px;
	font-size: ${typography.sizes.sml};
	line-height: 24px;
	color: ${palette.grey700};
`;

export const RadioSubActionsContent: React.FC<Props> = ({
	onChange,
	subActionOptions,
	defaultValue = subActionOptions[0]?.action,
}) => {
	const [selected, setSelected] = useState<DesktopAction>(defaultValue);

	useEffect(() => {
		onChange(selected);
	}, [selected, onChange]);

	const handleChange = (value: DesktopAction) => {
		setSelected(value);
	};

	return (
		<OptionsContainer>
			{subActionOptions.map(({ action, label, description }) => (
				<div key={action}>
					<StyledRadio
						label={label}
						checked={selected === action}
						onChange={() => handleChange(action)}
					/>
					<OptionDescription>{description}</OptionDescription>
				</div>
			))}
		</OptionsContainer>
	);
};
